export default {
	load() {
		return {
			fields: {
				cityId: {
					label: "Obec",
					rules: "required"
				},
				cityName: {},
				street: {
					label: "Ulica a číslo",
					rules: "required"
				},
				device: {
					label: "Zariadenie",
					type: "string",
					rules: "required"
				},
				deviceName: {},
				deviceCode: {},
				devicePower: {
					label: "Výkon zariadenia (kW)",
					type: "string",
					rules: "required"
				},
				deviceCapacity: {
					label: "Kapacita akumulácie (kWh)",
					type: "string"
				},
				deviceCadastralArea: {
					label: "Katastrálne územie (podľa LV)",
					type: "string"
				},
				deviceParcelNumber: {
					label: "Číslo parcely / parciel",
					type: "string"
				}
			}
		}
	}
}

